/** Сообщение о файлах cookie на главной странице (МР-09): портал использует только необходимые, баннер это объясняет */
import { useState } from 'react';
import { cookieNoticeSeen, type Dictionary, rememberCookieNotice } from './i18n';

export function CookieBanner({ t }: { t: Dictionary['cookie'] }) {
  const [shown, setShown] = useState(() => !cookieNoticeSeen());
  if (!shown) return null;
  const close = (choice: 'all' | 'necessary') => {
    rememberCookieNotice(choice);
    setShown(false);
  };
  const btn =
    'inline-flex h-11 min-w-11 items-center justify-center rounded-md px-4 text-[14px] font-semibold whitespace-nowrap';
  return (
    <section
      aria-label={t.aria}
      className="fixed inset-x-0 bottom-0 z-40 border-t border-line-strong bg-surface p-4 shadow-md"
    >
      <div className="mx-auto flex max-w-[1180px] flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <p className="text-[13px] leading-5 text-ink-2 md:max-w-[760px]">{t.text}</p>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => close('necessary')}
            className={`${btn} border border-line-strong text-ink hover:underline`}
          >
            {t.necessary}
          </button>
          <button
            type="button"
            onClick={() => close('all')}
            className={`${btn} bg-accent text-on-accent hover:underline`}
          >
            {t.accept}
          </button>
        </div>
      </div>
    </section>
  );
}
